module.exports = __webpack_public_path__ + "static/img/alexandra-gorn-JIUjvqe2ZHg-unsplash_thumb.34b8344.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/alexandra-gorn-JIUjvqe2ZHg-unsplash_thumb.png
// module id = cFmx
// module chunks = 4